import React, { useEffect } from 'react';

const queryString = require('query-string');

const LTILaunch = (props) => {
    useEffect(() => {
        const { token, membership } = queryString.parse(props.location.search);
        localStorage.removeItem('auth_token');
        if (token) {
            localStorage.setItem('auth_token', token);
            window.location.href = '/';
        } else if (membership === 'none') {
            window.location.href = '/lti-admin';
        } else if (token && !membership) {
            window.location.href = '/lti-incomplete';
        } else {
            window.location.href = '/lti-incomplete';
        }
    }, []);

    return <></>;
};

export default LTILaunch;
